export type TBannerType = "info" | "warning" | "error";

export const ignoreRouteNames = ["embed-advisor-org_id-portfolio-builder-pdf"];

export const useSystemBannersStore = defineStore("systemBanners", {
  state: () => ({
    bannerText: null as null | string,
    bannerType: null as null | TBannerType,
    closeCallback: null as null | (() => void),
  }),
  getters: {
    banner(state) {
      return state.bannerText && state.bannerType
        ? {
            type: state.bannerType,
            text: state.bannerText,
          }
        : null;
    },
  },
  actions: {
    setBanner(text: string, type: TBannerType = "info", callback?: () => void) {
      this.bannerText = text;
      this.bannerType = type;
      this.closeCallback = callback ?? null;
    },
    close() {
      this.bannerText = null;
      this.bannerType = null;
      if (this.closeCallback) {
        this.closeCallback();
        this.closeCallback = null;
      }
    },
  },
});
